
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"2","d":"M0 0h1v13H0V0zm3 0v1H1V0h2zm0 12v1H1v-1h2zM3 0h3v13H3V0zm5 0h1v13H8V0zm8 1h1v11h-1V1zm1-1v1H9V0h8zm0 12v1H9v-1h8z","fill":"#818181","fill-rule":"evenodd"}})])
          )
        }
      }
    